import {
  GraphModelManager,
  IObjectRenderer,
  IRenderTreeGroup,
  INode,
  ItemModelManager,
} from '@ardoq/yfiles';

class IsometricGraphModelManager extends GraphModelManager {
  override createNodeModelManager(
    renderer: IObjectRenderer<INode>,
    callback: (node: INode) => IRenderTreeGroup
  ): ItemModelManager<INode> {
    const result = super.createNodeModelManager(renderer, callback);
    result.comparator = (node1: INode, node2: INode) =>
      node2.layout.maxY - node1.layout.maxY;
    return result;
  }
}
export { IsometricGraphModelManager };
